export default () => ({
  users: null,
  editingUser: null,
  loading: false,
  allAgencies: null,
  allRoles: null,
  instanceId: null,
  page: 0,
  sortBy: "username",
  orderBy: "asc",
  search: "",
});
